<template>
  <qx-card title="资产看板">
    <iframe
      class="frameBox"
      :src="frameUrl" />
  </qx-card>
</template>

<script>
import {
  getAssetsReport,
} from 'api/report';
export default {
  data () {
    return {
      frameUrl: '',
    };
  },
  async created () {
    const res = await getAssetsReport();
    this.frameUrl = res.httpUrl;
  },
};
</script>

<style scoped lang="scss">
.frameBox{
  width: 100%;
  height: 600px;
  border: none;
}
</style>
